import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {TNR_ALIAS} from "../../../../../blink-sdk/Constants";
import {SadFaceIcon} from "../../../../../core/ui/SVGElements.jsx";
import {Messages} from "../../../../Messages";
import {MerchantButton} from "../../../../common/MerchantButton";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {BasePanelPage, BasePanelPageStyle} from "../../../PanelPage";
import {Controller} from "../../../Controller";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {PAYMENT_DETAILS_PANEL_URL} from "../../../PanelConstants";


export class PaymentFailedPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    title = {
        textAlign: "center",
        ...this.themeProps.MERCHANT_TITLE_STYLE,
    };

    @styleRule
    icon = {
        textAlign: "center",
    };

    @styleRule
    message = {
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
    };
}

@registerStyle(PaymentFailedPanelStyle)
export class PaymentFailedPanel extends BasePanelPage {
    formatPaymentErrorMessage(message) {
        let formattedMessage = (message || "").toString().trim();

        if (!formattedMessage.length) {
            return formattedMessage;
        }

        if (formattedMessage.slice(-1) !== ".") {
            formattedMessage += ".";
        }

        formattedMessage += " ";

        return formattedMessage;
    }

    render() {
        const {styleSheet, themeProps} = this;


        return [
            !iFrameMerchantService.isMerchant(TNR_ALIAS) &&
                <SadFaceIcon className={styleSheet.icon} color={themeProps.MERCHANT_TEXT_SECONDARY_COLOR}/>,
            <div testId="subscribeFailedTitle" className={styleSheet.title}>
                {Messages.subscribePaymentFailedModal}</div>,
            <div testId="subscribeFailedMessage" className={styleSheet.message}>
                {Controller.paymentMethod.isCDSPaymentError() && iFrameMerchantService.isMerchant(TNR_ALIAS)
                    ? Messages.tnrContactCustomerSupport
                    : [this.formatPaymentErrorMessage(Controller.paymentMethod.getPaymentErrorMessage()), Messages.subscribeFailedMessage]}
            </div>,
            <MerchantButton
                label={Messages.editPaymentDetails}
                className={styleSheet.actionButton}
                onClick={() => Router.changeURL(PAYMENT_DETAILS_PANEL_URL)}

            />,
            <div className={styleSheet.backButton}
                 onClick={() => {
                    const retryPayment = Controller.paymentMethod.retryPayment || Controller.paymentMethod.onSelectSuccess;
                    retryPayment();
                }}>
                {Messages.retryPaymentSubscribe}
            </div>,
        ];
    }

    onMount() {
        super.onMount();

        this.attachListener(Controller.paymentMethod, () => this.redraw());
    }
}
